export const LOCALES = {
  ENGLISH: 'en',
  ARABIC: 'ar',
} as const;

export const TEXT_DIRECTIONS = {
  LTR: 'ltr',
  RTL: 'rtl',
} as const;

export const INVITATION_STATES = {
  EXPIRED: 'EXPIRED',
} as const;

export type Locale = (typeof LOCALES)[keyof typeof LOCALES];

export const LOCALE_LABELS: Record<Locale, string> = {
  [LOCALES.ENGLISH]: 'EN',
  [LOCALES.ARABIC]: 'ع',
};
export type TextDirection = (typeof TEXT_DIRECTIONS)[keyof typeof TEXT_DIRECTIONS];
export type InvitationState = (typeof INVITATION_STATES)[keyof typeof INVITATION_STATES];
